var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.464,
    height: 362.47,
    viewBox: "0 0 272.464 362.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4097",
    "data-name": "Group 4097",
    transform: "translate(-995.536 -1256.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-11",
    transform: "translate(881.01 1201.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8947",
    "data-name": "Path 8947",
    d: "M281.492,235.812a18.45,18.45,0,0,1,2.638-3.756h0a8.732,8.732,0,1,0-11.6,0h0a18.535,18.535,0,0,1,2.535,3.558c-1.181,149.928-29.78,148.859-30.9,12.685,1.427-5.633,5.915-10.328,5.915-10.328h0a13.8,13.8,0,1,0-18.356,0v.047s4.695,4.939,6.028,10.816c-.413,133.767-25.952,132.443-31.82-13.023a18.449,18.449,0,0,1,2.638-3.756h0a8.732,8.732,0,1,0-11.6,0h0a18.533,18.533,0,0,1,2.535,3.558C192.928,380.522,281.957,382.609,281.492,235.812Z",
    transform: "translate(0 -9.708)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8948",
    "data-name": "Path 8948",
    d: "M217.176,224.122c0-2.009-1.624-5.2-3.643-5.2s-3.643,3.192-3.643,5.2,3.1,6.028,3.643,6.028S217.176,226.131,217.176,224.122Z",
    transform: "translate(-10.834 -10.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8949",
    "data-name": "Path 8949",
    d: "M297.736,224.122c0-2.009-1.624-5.2-3.643-5.2s-3.643,3.192-3.643,5.2,3.1,6.028,3.643,6.028S297.736,226.131,297.736,224.122Z",
    transform: "translate(-15.756 -10.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8950",
    "data-name": "Path 8950",
    d: "M214.22,197.459l25.689-22.609v19.182L215.929,205.3Z",
    transform: "translate(-11.099 -7.325)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8951",
    "data-name": "Path 8951",
    d: "M218.849,214.834H207.7l-2.357-43.781a4.582,4.582,0,0,1,0-.939c.385-3.615,3.756-15.464,7.924-15.464h0c4.141,0,7.511,11.849,7.934,15.464a5.33,5.33,0,0,1,0,.939Z",
    transform: "translate(-10.555 -6.091)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8952",
    "data-name": "Path 8952",
    d: "M207,163.766h12.769c-1.446-4.394-3.756-9.126-6.385-9.126S208.446,159.372,207,163.766Z",
    transform: "translate(-10.658 -6.09)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8953",
    "data-name": "Path 8953",
    d: "M207.32,208.91l.5,9.239h11.154l.5-9.239Z",
    transform: "translate(-10.677 -9.405)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8954",
    "data-name": "Path 8954",
    d: "M292.717,197.459,267,174.85v19.182L290.98,205.3Z",
    transform: "translate(-14.323 -7.325)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8955",
    "data-name": "Path 8955",
    d: "M288.726,214.834H299.88l2.357-43.781a4.584,4.584,0,0,0,0-.939c-.385-3.615-3.756-15.464-7.924-15.464h0c-4.141,0-7.511,11.849-7.934,15.464a5.333,5.333,0,0,0,0,.939Z",
    transform: "translate(-15.506 -6.091)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8956",
    "data-name": "Path 8956",
    d: "M300.5,208.91l-.5,9.239H288.848l-.5-9.239Z",
    transform: "translate(-15.627 -9.405)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8957",
    "data-name": "Path 8957",
    d: "M288,163.766h12.769c-1.455-4.394-3.756-9.126-6.385-9.126S289.465,159.372,288,163.766Z",
    transform: "translate(-15.606 -6.09)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8958",
    "data-name": "Path 8958",
    d: "M259.83,225.27a5.765,5.765,0,0,0-11.52,0c0,3.183,4.892,9.53,5.756,9.53C254.742,234.8,259.83,228.434,259.83,225.27Z",
    transform: "translate(-13.181 -10.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8959",
    "data-name": "Path 8959",
    d: "M267.7,193.367H238.524l-6.178-94.755a12.958,12.958,0,0,1,0-2.488c1.033-9.483,9.943-40.514,20.769-40.514h0c10.835,0,19.717,31.031,20.769,40.514a12.207,12.207,0,0,1,0,2.488Z",
    transform: "translate(-12.203 -0.04)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8960",
    "data-name": "Path 8960",
    d: "M253.7,172.3h0a12.769,12.769,0,0,1-12.769-12.76V106.35A12.769,12.769,0,0,1,253.7,93.59h0a12.769,12.769,0,0,1,12.76,12.76v53.189A12.769,12.769,0,0,1,253.7,172.3Z",
    transform: "translate(-12.731 -2.36)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8961",
    "data-name": "Path 8961",
    d: "M263.774,215.9H243.249L238.93,201.68h29.21Z",
    transform: "translate(-12.608 -8.964)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 8.92,
    cy: 8.92,
    r: 8.92,
    transform: "translate(229.333 100.907) rotate(-21.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 8.92,
    cy: 8.92,
    r: 8.92,
    transform: "translate(230.714 114.381) rotate(-80.94)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8962",
    "data-name": "Path 8962",
    d: "M253.934,102.124a8.366,8.366,0,0,1,8.356,8.037v-.338a8.375,8.375,0,0,0-16.741,0v.338A8.356,8.356,0,0,1,253.934,102.124Z",
    transform: "translate(-13.013 -2.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 6.657,
    cy: 6.657,
    r: 6.657,
    transform: "translate(233.282 112.479) rotate(-80.76)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8963",
    "data-name": "Path 8963",
    d: "M254.046,116.367a6.657,6.657,0,0,0,6.648-6.347v.31a6.657,6.657,0,1,1-13.314,0v-.31a6.657,6.657,0,0,0,6.666,6.347Z",
    transform: "translate(-13.125 -3.364)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 8.92,
    cy: 8.92,
    r: 8.92,
    transform: "translate(232.002 119.002)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 8.92,
    cy: 8.92,
    r: 8.92,
    transform: "translate(232.002 120.073)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8964",
    "data-name": "Path 8964",
    d: "M253.934,125.584a8.366,8.366,0,0,1,8.356,8.037v-.338a8.375,8.375,0,0,0-16.741,0v.338a8.356,8.356,0,0,1,8.384-8.037Z",
    transform: "translate(-13.013 -4.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 6.657,
    cy: 6.657,
    r: 6.657,
    transform: "translate(234.265 122.336)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8965",
    "data-name": "Path 8965",
    d: "M254.046,139.827a6.657,6.657,0,0,0,6.648-6.347v.31a6.657,6.657,0,0,1-13.314,0v-.31a6.657,6.657,0,0,0,6.666,6.347Z",
    transform: "translate(-13.125 -4.797)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 8.92,
    cy: 8.92,
    r: 8.92,
    transform: "translate(229.339 144.962) rotate(-21.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 8.92,
    cy: 8.92,
    r: 8.92,
    transform: "translate(230.718 158.434) rotate(-80.94)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8966",
    "data-name": "Path 8966",
    d: "M253.934,149.044a8.366,8.366,0,0,1,8.356,8.037v-.338a8.375,8.375,0,0,0-16.741,0v.338A8.356,8.356,0,0,1,253.934,149.044Z",
    transform: "translate(-13.013 -5.724)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 6.657,
    cy: 6.657,
    r: 6.657,
    transform: "translate(233.283 156.527) rotate(-80.76)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8967",
    "data-name": "Path 8967",
    d: "M254.046,163.287a6.657,6.657,0,0,0,6.648-6.347v.31a6.657,6.657,0,0,1-13.314,0v-.31a6.657,6.657,0,0,0,6.666,6.347Z",
    transform: "translate(-13.125 -6.231)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8968",
    "data-name": "Path 8968",
    d: "M238.74,74.094H268.3c-3.756-9.924-8.967-19.144-14.778-19.144h0C247.716,55,242.477,64.17,238.74,74.094Z",
    transform: "translate(-12.597)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x2: 0.028,
    y2: 0.563,
    transform: "translate(221.392 162.155)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x2: 0.019,
    y2: 0.423,
    transform: "translate(221.402 162.296)",
    fill: "#9ba7ac"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x2: 0.009,
    y2: 0.178,
    transform: "translate(221.411 162.54)",
    fill: "#697b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-11",
    transform: "translate(848.292 1194.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 228.78,
    height: 148.03,
    transform: "translate(150.97 252.63)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 228.78,
    height: 45.87,
    transform: "translate(150.97 354.79)",
    fill: "#6b6b6b",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1385",
    "data-name": "Rectangle 1385",
    width: 78.6,
    height: 60.22,
    transform: "translate(156.52 315.38)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1386",
    "data-name": "Rectangle 1386",
    width: 72.26,
    height: 52.97,
    transform: "translate(159.68 319)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x1: 3.57,
    y2: 3.16,
    transform: "translate(176.09 364.75)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x1: 44.5,
    y2: 39.42,
    transform: "translate(184.79 320.78)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x1: 25.45,
    y2: 22.55,
    transform: "translate(193.7 335.62)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1387",
    "data-name": "Rectangle 1387",
    width: 78.6,
    height: 60.22,
    transform: "translate(296.11 315.38)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1388",
    "data-name": "Rectangle 1388",
    width: 72.26,
    height: 52.97,
    transform: "translate(299.28 319)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x1: 3.57,
    y2: 3.16,
    transform: "translate(315.69 364.75)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 44.49,
    y2: 39.42,
    transform: "translate(324.39 320.78)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 25.45,
    y2: 22.55,
    transform: "translate(333.3 335.62)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8969",
    "data-name": "Path 8969",
    d: "M300.11,391.61l-4-6.25,6.25,2.25-.75-6,3.25,5,.25-9,1.75,6,4-11.25.5,11.75,4.75-2.75-2.75,5.25,3.5-2.25-.25,3.75,4.5-2.25-3,5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8970",
    "data-name": "Path 8970",
    d: "M326.36,391.61l-4-6.25,6.25,2.25-.75-6,3.25,5,.25-9,1.75,6,4-11.25.5,11.75,4.75-2.75-2.75,5.25,3.5-2.25-.25,3.75,4.5-2.25-3,5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8971",
    "data-name": "Path 8971",
    d: "M352.36,391.61l-4-6.25,6.25,2.25-.75-6,3.25,5,.25-9,1.75,6,4-11.25.5,11.75,4.75-2.75-2.75,5.25,3.5-2.25-.25,3.75,4.5-2.25-3,5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8972",
    "data-name": "Path 8972",
    d: "M158.86,391.61l-4-6.25,6.25,2.25-.75-6,3.25,5,.25-9,1.75,6,4-11.25.5,11.75,4.75-2.75-2.75,5.25,3.5-2.25-.25,3.75,4.5-2.25-3,5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8973",
    "data-name": "Path 8973",
    d: "M185.11,391.61l-4-6.25,6.25,2.25-.75-6,3.25,5,.25-9,1.75,6,4-11.25.5,11.75,4.75-2.75-2.75,5.25,3.5-2.25-.25,3.75,4.5-2.25-3,5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8974",
    "data-name": "Path 8974",
    d: "M211.11,391.61l-4-6.25,6.25,2.25-.75-6,3.25,5,.25-9,1.75,6,4-11.25.5,11.75,4.75-2.75-2.75,5.25,3.5-2.25-.25,3.75,4.5-2.25-3,5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1389",
    "data-name": "Rectangle 1389",
    width: 228.78,
    height: 10.6,
    transform: "translate(150.97 390.05)",
    fill: "#6b6b6b",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1390",
    "data-name": "Rectangle 1390",
    width: 49.6,
    height: 90.41,
    transform: "translate(240.25 310.24)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8975",
    "data-name": "Path 8975",
    d: "M285.92,361.73H243.39V314.64h42.53Zm0,5H243.39v28.88h42.53Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1391",
    "data-name": "Rectangle 1391",
    width: 1.55,
    height: 16.51,
    transform: "translate(286.89 350.66)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 2.46,
    y2: 2.18,
    transform: "translate(247.5 352.16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 30.68,
    y2: 27.17,
    transform: "translate(253.49 321.86)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 17.54,
    y2: 15.55,
    transform: "translate(259.64 332.08)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x1: 1.89,
    y2: 1.68,
    transform: "translate(255.96 390.87)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x1: 23.6,
    y2: 20.91,
    transform: "translate(260.57 367.55)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x1: 13.49,
    y2: 11.96,
    transform: "translate(265.3 375.42)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1392",
    "data-name": "Rectangle 1392",
    width: 228.29,
    height: 30.72,
    transform: "translate(151.46 287.48)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    width: 235.44,
    height: 43.82,
    transform: "translate(147.72 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1394",
    "data-name": "Rectangle 1394",
    width: 10.84,
    height: 43.82,
    transform: "translate(160.3 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1395",
    "data-name": "Rectangle 1395",
    width: 10.84,
    height: 43.82,
    transform: "translate(183.27 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1396",
    "data-name": "Rectangle 1396",
    width: 10.84,
    height: 43.82,
    transform: "translate(206.25 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1397",
    "data-name": "Rectangle 1397",
    width: 10.84,
    height: 43.82,
    transform: "translate(228.11 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1398",
    "data-name": "Rectangle 1398",
    width: 10.84,
    height: 43.82,
    transform: "translate(249.97 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1399",
    "data-name": "Rectangle 1399",
    width: 10.84,
    height: 43.82,
    transform: "translate(271.82 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1400",
    "data-name": "Rectangle 1400",
    width: 10.84,
    height: 43.82,
    transform: "translate(293.68 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1401",
    "data-name": "Rectangle 1401",
    width: 10.84,
    height: 43.82,
    transform: "translate(315.54 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1402",
    "data-name": "Rectangle 1402",
    width: 10.84,
    height: 43.82,
    transform: "translate(337.4 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 10.84,
    height: 43.82,
    transform: "translate(359.25 269.74)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11",
    transform: "translate(1153.66 1370.868)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 57.17,
    cy: 12.524,
    rx: 57.17,
    ry: 12.524,
    transform: "translate(0 222.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 57.17,
    cy: 12.524,
    rx: 57.17,
    ry: 12.524,
    transform: "translate(0 222.998)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8978",
    "data-name": "Path 8978",
    d: "M121.843,311.63s6.066,18.644,7.42,28.077,4.044,35.72,4.044,35.72a43.808,43.808,0,0,1,9.095,20.55c1.684,12.026,1.122,28.22,1.122,28.22a8.638,8.638,0,0,1,1.345,3.038c0,1.015-.223,3.26-.223,3.26a84.544,84.544,0,0,1,7.082,6.173c2.467,2.583,2.022,7.082,2.022,8.311s-1.461,3.038-2.254,3.038-6.173-1.016-8.908-3.26-2.806-6.85-3.483-8.908-5.238-8.088-5.238-8.088a3,3,0,0,1-2.672-2.672c-.223-2.467-.784-6.85-1.007-7.75s-9.665-16.177-11.794-25.387-8.765-23.018-11.126-29.084-7.411-18.421-7.411-18.421l-1.015-.339s1.915,26.723,2.476,35.159.677,10.556.677,21.673-4.383,29.4-4.383,29.4v5.728c0,.339-.891.677-2.583.784s-6.645.134-7.883.891-6.289,1.345-11.455,1.122-7.866-1.122-7.3-2.138,9.433-4.454,10.894-5.389,4.855-3.171,4.855-3.171-.232-2.913.561-4.267,1.122-1.229,1.122-2.672-3.26-20.559-4.16-29.654-5.728-22.02-6.066-31.676.561-17.076,1.354-28.086a92.408,92.408,0,0,1,3.474-19.428Z",
    transform: "translate(-54.866 -204.147)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8979",
    "data-name": "Path 8979",
    d: "M127.62,312.364l15.615-.294v3.759H127.62Z",
    transform: "translate(-97.147 -204.195)",
    fill: "#595959",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8980",
    "data-name": "Path 8980",
    d: "M151.245,315.87H147.29c.526-2.138.891-3.367.891-3.367l3.038-.062Z",
    transform: "translate(-122.678 -204.236)",
    fill: "#595959",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8981",
    "data-name": "Path 8981",
    d: "M122.159,315.8H112.61v-3.83l9.549-.178Z",
    transform: "translate(-62.7 -204.165)",
    fill: "#595959",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8982",
    "data-name": "Path 8982",
    d: "M102.7,311.728l5.5-.1s.534,1.621,1.309,4.151H102.7Z",
    transform: "translate(-41.219 -204.147)",
    fill: "#595959",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1406",
    "data-name": "Rectangle 1406",
    width: 6.289,
    height: 3.483,
    transform: "translate(34.518 108.044)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8983",
    "data-name": "Path 8983",
    d: "M155.439,328.78s-2.022,8.641-1.461,13.923c.214,2.013,2.922,7.866,3.483,8.2a2.762,2.762,0,0,0,1.684,0,25.832,25.832,0,0,1-1.007-3.376c-.116-.891-.232-3.367-.232-3.367a32.55,32.55,0,0,0,2.254,4.16,10.689,10.689,0,0,0,2.583,1.906,1.336,1.336,0,0,0,1.007-.561c.223-.339-.891-1.122-1.461-2.361s-1.461-3.563-1.461-3.563a24.47,24.47,0,0,0,2.672,2.913,9.8,9.8,0,0,0,2.922,1.461c.339,0,1.007-1.229.668-1.345a15.1,15.1,0,0,1-3.474-2.245,12.775,12.775,0,0,0-1.015-1.345,33.917,33.917,0,0,0,4.044,1.345c.561,0,.784-.891.784-.891l-3.706-1.906-.891-2.254a10.306,10.306,0,0,0,0-5.273c-.784-2.583-1.122-4.383-1.122-4.383Z",
    transform: "translate(-144.732 -206.021)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8984",
    "data-name": "Path 8984",
    d: "M167.767,332.94s-.107,3.706-.784,4.454-1.906,1.684-1.906,2.467,1.229,5.282.891,5.621a.891.891,0,0,1-1.577-.339,42.632,42.632,0,0,1-1.461-7.527",
    transform: "translate(-153.131 -206.475)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8985",
    "data-name": "Path 8985",
    d: "M157.726,259.524s-3.038,18.314-3.367,23.819S154.02,293,154.02,293l-5.843,28.086,6.289,1.007s7.411-15.143,8.908-16.925,2.254-5.167,1.684-9.995-.107-31.231-1.229-34.375a3.608,3.608,0,0,0-6.1-1.274Z",
    transform: "translate(-137.47 -198.326)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x1: 6.289,
    y1: 1.684,
    transform: "translate(11.491 120.283)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8986",
    "data-name": "Path 8986",
    d: "M111.575,239s24.6,10.208,25.726,10.689,1.906,0,2.467,2.245,9.888,42.294,9.46,45.465-7.322,30.678-7.322,30.678l-7.759-1.345-.891-33.137-4.16-10.565s-5.5,13.816-5.389,14.947,1.461,3.706.668,5.167a5.657,5.657,0,0,1-1.684,2.022H79.934s-2.672-.891-2.806-2.138a35.8,35.8,0,0,1,.668-5.389s-3.813-15.054-3.813-25.5,1.229-19.089,2.922-21.566,7.75-4.944,13.246-6.85,10.11-3.706,15.054-4.151S111.575,239,111.575,239Z",
    transform: "translate(-55.376 -196.214)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8987",
    "data-name": "Path 8987",
    d: "M142.411,248.45s-3.813,17.121-3.813,26.723-.258,21.094-.775,22.92-1.309,4.944.517,7.028",
    transform: "translate(-104.856 -197.247)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x1: 6.85,
    y1: 16.622,
    transform: "translate(66.87 70.186)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x1: 6.405,
    y1: 8.088,
    transform: "translate(63.833 71.086)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x1: 8.543,
    y1: 0.9,
    transform: "translate(78.771 127.472)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8988",
    "data-name": "Path 8988",
    d: "M141.423,242.53l-2.583,5.5,5.843-3.251Z",
    transform: "translate(-108.589 -196.6)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8989",
    "data-name": "Path 8989",
    d: "M141.921,247.527l-4.721-5.273L141.805,240Z",
    transform: "translate(-104.366 -196.324)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M124.335,200.258s-3.029,3.367-3.029,4.374a20.573,20.573,0,0,0,.223,2.476s-5.051,2.467-4.454,3.483a27.358,27.358,0,0,1,1.345,2.913s-4.151,9.1-3.563,10,6.289,6.4,7.3,9.095,3.038,10.333,3.038,10.333l19.321-10.689s-2.361-3.813-2.476-6.4-.445-4.605,0-6.182,2.806-5.621,3.038-9.549-4.044-8.534-9.665-11.233S124.335,200.258,124.335,200.258Z",
    transform: "translate(-87.573 -191.732)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8991",
    "data-name": "Path 8991",
    d: "M140.449,218.31a4.605,4.605,0,0,1-5.389,1.131",
    transform: "translate(-100.988 -193.955)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8992",
    "data-name": "Path 8992",
    d: "M136.132,210.183c-.3.65-.2,1.336.223,1.523s1.007-.169,1.309-.82.187-1.336-.232-1.523S136.426,209.533,136.132,210.183Z",
    transform: "translate(-99.174 -192.972)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M136.82,209.434a3.937,3.937,0,0,0-4.16-2.467",
    transform: "translate(-95.221 -192.712)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.902
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M127.93,218.138s-2.922,0-2.922-1.577,2.245-4.712,1.684-6.289-3.251-2.672-2.245-4.383,3.038-1.684,1.906-2.806-9.433.339-12.239-2.672-3.928-7.634-1.906-8.525,4.605,1.345,4.605,1.345,1.345-3.144,5.389-2.022,9.656,5.5,12.8,9.888,4.276,5.95,3.038,8.908-5.282,8.427-6.85,9.326S127.93,218.138,127.93,218.138Z",
    transform: "translate(-77.797 -190.968)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M130.439,222.621s3.144-4.5,5.843-3.937,2.022,4.5.223,6.289-4.944.561-5.612.116c0,0-2.476,5.95-4.944,6.182s-9.433-2.815-9.433-2.815",
    transform: "translate(-82.106 -193.99)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M133.123,241.64l-3.483,6.066,6.734-3.367Z",
    transform: "translate(-92.085 -196.503)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8997",
    "data-name": "Path 8997",
    d: "M128.619,233.32l-15.5,7.411,3.59,8.765,14.377-10.787Z",
    transform: "translate(-72.082 -195.594)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8998",
    "data-name": "Path 8998",
    d: "M140.336,317.8s-1.461,9.442.116,14.609",
    transform: "translate(-105.142 -204.821)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8999",
    "data-name": "Path 8999",
    d: "M135.2,320.2s-1.461,9.326-.891,15.838",
    transform: "translate(-94.958 -205.083)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9000",
    "data-name": "Path 9000",
    d: "M133.35,336c.339.339,2.922,1.577,3.563,3.144a48.411,48.411,0,0,0,2.361,4.383",
    transform: "translate(-98.289 -206.809)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 3.029,
    y2: 9.211,
    transform: "translate(52.832 112.418)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 0.677,
    y2: 14.493,
    transform: "translate(51.594 112.533)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x1: 1.915,
    y2: 8.32,
    transform: "translate(25.307 112.418)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9001",
    "data-name": "Path 9001",
    d: "M147.42,317.43s.784,7.857.784,8.2",
    transform: "translate(-119.753 -204.781)",
    fill: "none",
    stroke: "#5c656a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9002",
    "data-name": "Path 9002",
    d: "M76.537,353.35H92.651A1.247,1.247,0,0,1,93.9,354.6v6.574a1.247,1.247,0,0,1-1.247,1.247H90.763a1.247,1.247,0,0,0,1.247-1.247v-4.294a1.247,1.247,0,0,0-1.247-1.247H78.426a1.247,1.247,0,0,0-1.247,1.247v4.294a1.247,1.247,0,0,0,1.247,1.247H76.537a1.247,1.247,0,0,1-1.247-1.247V354.6a1.247,1.247,0,0,1,1.247-1.247Z",
    transform: "translate(-1.195 -208.704)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9003",
    "data-name": "Path 9003",
    d: "M90.191,338.832s2.361,9.211,1.915,10.778-1.692,2.476-1.782,2.815a1.176,1.176,0,0,0,.454,1.345l.561.339s.445,0,.107.668a1.835,1.835,0,0,1-.713.891c-.739.374-1.194-.383-1.862-.481s-1.087.632-1.719.588-.971-.677-1.586-.624-1.015,1.167-1.906.775c-.383-.178-.659-.561-1.042-.757-.57-.294-1.381-.214-1.888-.65a2.61,2.61,0,0,1-.713-1.568c-.2-1.149,2.441-15.491,2.441-15.491Z",
    transform: "translate(-3.661 -206.969)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1407",
    "data-name": "Rectangle 1407",
    width: 54.89,
    height: 37.466,
    rx: 3.99,
    transform: "translate(57.027 150.855)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9004",
    "data-name": "Path 9004",
    d: "M108.482,364.2,82.525,382.532a4.133,4.133,0,0,1-4.819,0L53.86,365.18",
    transform: "translate(3.31 -209.889)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1408",
    "data-name": "Rectangle 1408",
    width: 4.418,
    height: 6.209,
    transform: "translate(81.248 170.175)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.951
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart4);
export default __webpack_public_path__ + "static/media/start4.09be761920de6a15bba0b321263bd3b9.svg";
export { ForwardRef as ReactComponent };